import React, { useState, useEffect } from 'react';


import { 
    DashboardLayout, Button, Spinner, AlertMessage,
    FormInput_text,
} from "components";

import { func_validation, isArrayNotEmpty } from "functions";

import ic_small_add from "assets/images/ic_small_add.svg";
import ic_small_save from "assets/images/ic_small_save.svg";

import "assets/scss/distributorPortal/modules/userManagement/userGroupUpdate.scss";
import { ListBox } from 'components/form/ListBox';



export default function UserGroupUpdatePresentation(props) {    
    // Props  
    const { 
        isEditing, 
        userList, getUserList_requesting,
        userLabels,

        isUserRecordUpdatedSuccessfully,

        addUserGroup_requesting, updateUserGroup_requesting,

        userGroupPermissionList, userGroupPermissionLabels, userGroupPermissionList_requesting,
    } = props;

    // Validate Props
    let isLoading = addUserGroup_requesting || updateUserGroup_requesting;
    
    // States

    const [isFormSubmissionAttempted, setFormSubmissionStatus] = useState(false);

    const [groupName, setGroupName] = useState();

    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedUserGroupPermissions, setSelectedUserGroupPermissions] = useState([]);

    // Page Header
    let pageHeaderTitle = isEditing? "Edit Group": "Add New Group";
    
    // Error Messages
    const { 
        alertMsg,
        isAlertMsgVisible, setIsAlertMsgVisible
    } = useErrorHandling({ ...props, isFormSubmissionAttempted });

    // Submits
    let submitIcon = isEditing? ic_small_save: ic_small_add;
    let submitText = isEditing? "Save": "Add";
    let submitAltText = isEditing? "Save Icon": "Add Icon";
    function handleSubmission() {
        // Store a collection of usernames
        let userList = [];
        if (func_validation.isArrayNotEmpty(selectedUsers)) {
            selectedUsers.map((userGroup, idx) => {
                let username = func_validation.getObjectPropertyValue(userGroup, "UserName", "");
                if (func_validation.isStringTrimNotEmpty(username)) {
                    userList.push(username);
                }
            })
        }

        // Store a collection of permissions
        let permissionList_new = [];
        if (func_validation.isArrayNotEmpty(selectedUserGroupPermissions)) {
            selectedUserGroupPermissions.map((userGroupPermissionObj, idx) => {
                let permissionList = func_validation.getObjectPropertyValue(userGroupPermissionObj, "PermissionList");
                if (func_validation.isArrayNotEmpty(permissionList)) {
                    permissionList.map((permissionObj) => {
                        let fullPermissionString = func_validation.getObjectPropertyValue(permissionObj, "Original");
                        if (func_validation.isStringTrimNotEmpty(fullPermissionString))
                            permissionList_new.push(fullPermissionString);
                    })
                }
            })
        }

        // Note: Group name is only 1 value even though it is passed as an array
        //       due to API structure.
        if (func_validation.isStringTrimNotEmpty(groupName) 
            // &&
            // func_validation.isArrayNotEmpty(userList) &&
            // func_validation.isArrayNotEmpty(permissionList_new)
            ) {

            if (props.addUserGroup) 
                props.addUserGroup([groupName], userList, permissionList_new);
        }

        setFormSubmissionStatus(true);
    }
    function handleSuccessfulSubmission() {
        if (isUserRecordUpdatedSuccessfully &&
            isFormSubmissionAttempted &&
            props.updateParentState_visiblity)
            props.updateParentState_visiblity(false);
    }
    useEffect(() => {
        handleSuccessfulSubmission();
    }, [isUserRecordUpdatedSuccessfully]);

    return (
        <DashboardLayout
            headerTitle={pageHeaderTitle}
            isHeaderCloseIconVisible

            updateParentState_visiblity={props.updateParentState_visiblity}

            bodyClassName={"userGroupUpdate"}
            body={(
                <React.Fragment>
                    <div className="userGroupUpdate-subHeader d-flex justify-content-between">
                        {/* Title */}
                        <span className={"userGroupUpdate-subHeader-title"}>Insert Info</span>

                        {/* Action */}
                        <Button
                            className={"userGroupUpdate-subHeader-action"}
                            handleOnClick={handleSubmission}
                            isDecoration_transparentDarkGreyBorder
                        >
                            <div className={"d-flex flex-column align-items-center justify-content-center"}>
                                {isLoading? (
                                    <Spinner size={0} isLeftMarginOptional />
                                ):(
                                    <img
                                        src={submitIcon}
                                        alt={submitAltText}
                                        className={"userGroupUpdate-subHeaderAction-icon"}
                                    />
                                )}
                                <div className={"userGroupUpdate-subHeaderAction-text"}>
                                    {submitText}
                                </div>
                            </div>
                        </Button>
                    </div>

                    <div className="userGroupUpdate-inputWrapper ">
                        {/* Alert Error Messages */}
                        <AlertMessage
                            message={alertMsg}
                            isVisible={isAlertMsgVisible}
                            toggleVisibility={() => { setIsAlertMsgVisible(!isAlertMsgVisible); }}
                        />
                        
                        <div className="userGroupUpdate-inputWrapper-groupInfo d-flex">                                    
                            {/* Group Name */}
                            <FormInput_text  
                                inputLabel={"Group Name"}

                                className={"userGroupUpdate-inputWrapper-groupName"}
                                inputValue_default={groupName} 

                                isInputBlurHandlingRequired
                                handleInputBlurExtend={(value) => { setGroupName(value); }}

                                inputMaxLength={200}

                                customErrorMsgDefault={"Required"}
                                isFormSubmissionAttempted={isFormSubmissionAttempted} 

                                isMarginBtmOptional
                            />
                        </div>

                        <div className="userGroupUpdate-inputWrapper-listBoxes d-flex">                                    
                            {/* Add User List */}
                            <ListBox
                                className={"userGroupUpdate-inputWrapper-listBoxes-user"}
                                listWrapperClassName={"userGroupUpdate-listBoxes-user-listWrapper"}
                                listBodyClassName={"userGroupUpdate-listBoxes-user-listBody"}

                                customSelectionIndicatorTxt={"User(s) Selected"}

                                title={"Add User Into Group"}
                                // isInputRequired
                                isFormSubmissionAttempted={isFormSubmissionAttempted}

                                list={(func_validation.isUserAccessGranted(props, "Dealer_UserGroupMapping_View")) && isArrayNotEmpty(userList) && isArrayNotEmpty(userLabels)? 
                                    userLabels.map((name, idx) => {
                                        return {
                                            label: name, 
                                            data: userList[idx]
                                        }
                                }):[]}
                                isListLoading={getUserList_requesting}

                                updateParentState={setSelectedUsers}

                                isDisabled={false && func_validation.isUserAccessDenied(props, "Dealer_UserGroupMapping_Add")}
                            />

                            {/* Add Permission List */}
                            <ListBox
                                className={"userGroupUpdate-inputWrapper-listBoxes-permission"}
                                listWrapperClassName={"userGroupUpdate-listBoxes-permission-listWrapper"}
                                listBodyClassName={"userGroupUpdate-listBoxes-permission-listBody"}

                                customSelectionIndicatorTxt={"Permission(s) Selected"}

                                title={"Permission(s) Allowed"}
                                // isInputRequired
                                isFormSubmissionAttempted={isFormSubmissionAttempted}

                                list={(func_validation.isUserAccessGranted(props, "Dealer_Permission_View")) && isArrayNotEmpty(userGroupPermissionList) && isArrayNotEmpty(userGroupPermissionLabels)? 
                                    userGroupPermissionLabels.map((name, idx) => {
                                        return {
                                            label: name, 
                                            data: userGroupPermissionList[idx]
                                        }
                                }):[]}
                                isListLoading={userGroupPermissionList_requesting}

                                updateParentState={setSelectedUserGroupPermissions}

                                isDisabled={false && func_validation.isUserAccessDenied(props, "Dealer_Permission_Add")}
                            />
                        </div>   

                    </div>
                </React.Fragment>
            )}

            updateParentState_visiblity={props.updateParentState_visiblity}
        />
    );
}


function useErrorHandling(props) {
    const {
        addUser_errorMsg,
        isFormSubmissionAttempted
    } = props;

    // States
    const [alertMsg, setAlertMsg] = useState("");
    const [isAlertMsgVisible, setIsAlertMsgVisible] = useState(false);

    function handleError(errorMsg) {
        if (func_validation.isStringTrimNotEmpty(errorMsg) && 
            isFormSubmissionAttempted) {

            setAlertMsg(errorMsg);
            setIsAlertMsgVisible(true);
        }
    }
    useEffect(() => {
        handleError(addUser_errorMsg);
    }, [addUser_errorMsg]);
    
    return {
        alertMsg,
        isAlertMsgVisible, setIsAlertMsgVisible
    }
}